import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getBaseURL } from "@/lib/api";
import { log } from '@/lib/logger';

/**
 * Handles Strava OAuth callback when Strava redirects to the frontend domain
 * (e.g. https://athletespace.ai/auth/strava/callback).
 * Forwards code and state to the backend so it can exchange the code and set cookies.
 */
export default function StravaCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code = searchParams.get("code");
  const state = searchParams.get("state");

  useEffect(() => {
    if (!code || !state) {
      log.warn("STRAVA", "Missing code or state, redirecting to settings");
      navigate("/settings", { replace: true });
      return;
    }
    const apiBase = getBaseURL();
    const params = new URLSearchParams({ code, state });
    const backendCallbackUrl = `${apiBase}/auth/strava/callback?${params.toString()}`;
    window.location.href = backendCallbackUrl;
  }, [code, state, navigate]);

  return (
    <div className="min-h-[100svh] flex items-center justify-center bg-background">
      <p className="text-muted-foreground">Connecting Strava…</p>
    </div>
  );
}
